import { AxiosRequestConfig } from "axios";

import { axiosInstance } from "@/services/api/axiosConfig";

import { setNotifications } from "../redux/notifications.slice";
import { store } from "../redux/store";

export const getNotifications = async (options: AxiosRequestConfig) => {
  const { data: { data } } = await axiosInstance.get(`/notifications/`, options);

  store?.dispatch(setNotifications(data.notifications));
};

export const updateFCMToken = (token: string) => {
  return axiosInstance.put("/fcm/", {
    fcm_token: token,
    platform_type: "WEB",
  });
};
